import { Roles } from "../../../../auth/rolesPermissions";

export function normalizeOrderCodes(product) {
    let bcnu = product?.BCNU || "";
    let dealerCode = product?.dealerCode || "";

    const scnu = product?.SCNU || "";

    let ownerCode = product?.ownerCode || "";

    if (!bcnu && dealerCode) {
        bcnu = dealerCode;
    }

    if (!dealerCode && bcnu) {
        dealerCode = bcnu;
    }

    if (!ownerCode && bcnu && scnu) {
        ownerCode = `${bcnu}-${scnu}`;
    }

    return {
        BCNU: bcnu,
        customerCode: bcnu || dealerCode || "",
        dealerCode,
        deliveryCode: ownerCode || "",
        ownerCode: ownerCode || ""
    };
}

export function buildOrderNumber(orderReference, dealerCode, userRole) {
    const normalizedReference = String(orderReference || "").trim();

    if (userRole === Roles.WAREHOUSEUSER) {
        const normalizedDealerCode = String(dealerCode || "").trim();

        return normalizedDealerCode
            ? `${normalizedDealerCode}_${normalizedReference}`
            : normalizedReference;
    }

    return normalizedReference;
}

export function formatReturnedOrderNumber(orderNumber, userContext) {
    const number =
        String(orderNumber || "").trim();

    if (userContext.userRole !== Roles.WAREHOUSEUSER) {
        return number;
    }

    const dealerCode =
        String(userContext.dealerCode || "").trim();

    const prefix = `${dealerCode}_`;

    return number.startsWith(prefix)
        ? number.substring(prefix.length)
        : number;
}